const EXPORT = 'Export'
const ALL_LOANS = 'All Loans'
const VIEW_TRANSACTIONS = 'View Transactions'
const Title = 'Pending Disbursement'
export { ALL_LOANS, EXPORT, VIEW_TRANSACTIONS, Title }
